module.exports={render:function (){var _vm=this;
  return _vm._h('div', [_vm._m(0), " ", _vm._h('div', {
    staticClass: "main-page"
  }, [_vm._h('div', {
    staticClass: "about-app"
  }, [_vm._h('div', {
    staticClass: "text-center margin-15 padding-15"
  }, [_vm._h('img', {
    staticStyle: {
      "margin": "0 auto"
    },
    attrs: {
      "src": _vm.logo_yd,
      "width": "100",
      "height": "100"
    }
  }), " ", _vm._h('span', {
    staticClass: "padding-15 block"
  }, ["少儿之家园点端 v2.0"])]), " ", _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "topbar"
  }, [_vm._h('div', {
    staticClass: "clearfix main-wrap"
  }, [_vm._h('a', {
    staticClass: "pull-left img-back",
    attrs: {
      "href": "javascript:window.history.go(-1)"
    }
  }, ["返回"]), " ", _vm._h('h1', ["关于少儿之家园点端"])]), " ", _vm._h('div', {
    staticClass: "liner"
  })])
},function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "bg-white padding-15"
  }, [_vm._h('p', ["托管教育园点招生管理神器"])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.1@vue-loader/lib/template-compiler.js?id=data-v-d9c86d20!./~/.10.0.1@vue-loader/lib/selector.js?type=template&index=0!./src/views/user/userCollection/About.vue
// module id = 225
// module chunks = 1